export default (entry, callback) => (_response, formData) => {
  callback(entry, formData);
};
